export const NEW_COMPLECTATION = 'new';

const normalizeTitle = (title) => (title || '').toLowerCase().replace(/\s+/g, ' ').trim();

// ÐÐ¾Ð¿ÑÐ¾Ñ Ð·Ð°Ð´Ð°ÑÑÑÑ Ð¾Ð´Ð¸Ð½ Ð½Ð° Â«Ð¼Ð¾Ð´ÐµÐ»Ñ + Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¸Ð· Ð²ÑÐ³ÑÑÐ·ÐºÐ¸Â»: Ð¿ÑÑÐ½Ð°Ð´ÑÐ°ÑÑ Ð¼Ð°ÑÐ¸Ð½
// Â«ADVENTURE 1.6Â» â ÑÑÐ¾ Ð¾Ð´Ð¸Ð½ Ð¾ÑÐ²ÐµÑ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑÐ°, Ð° Ð½Ðµ Ð¿ÑÑÐ½Ð°Ð´ÑÐ°ÑÑ
export const groupComplectationRows = (rows) => {
  const groups = new Map();
  rows.forEach((row) => {
    const key = `${row.resolvedModelId}|${normalizeTitle(row.complectationName)}`;
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        title: (row.complectationName || '').trim(),
        markName: row.markName,
        modelName: row.modelName,
        candidates: row.complectationCandidates || [],
        suggestedId: row.suggestedComplectationId ?? null,
        rows: [],
      });
    }
    groups.get(key).rows.push(row);
  });
  return Array.from(groups.values());
};

export const candidateLabel = (c) => [c.title, c.engineVolume, c.transmission].filter(Boolean).join(' Â· ');

export const complectationOptions = (group) => [
  ...group.candidates.map((c) => ({ value: c.id, label: candidateLabel(c) })),
  { value: NEW_COMPLECTATION, label: `ï¼ Ð¡Ð¾Ð·Ð´Ð°ÑÑ Ð½Ð¾Ð²ÑÑ Â«${group.title}Â»` },
];

// ÐÑÐ²ÐµÑ Ð¿Ð¾ ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ â Ð¿Ð¾Ð´ÑÐºÐ°Ð·ÐºÐ° Ð±ÑÐºÐ° (ÐµÑÐ»Ð¸ Ð¾Ð½Ð° Ð¾Ð´Ð½Ð¾Ð·Ð½Ð°ÑÐ½Ð°); Â«ÑÐ¾Ð·Ð´Ð°ÑÑ Ð½Ð¾Ð²ÑÑÂ» Ð¿Ð¾
// ÑÐ¼Ð¾Ð»ÑÐ°Ð½Ð¸Ñ Ð½Ðµ Ð²ÑÐ±Ð¸ÑÐ°ÐµÑÑÑ Ð½Ð¸ÐºÐ¾Ð³Ð´Ð°, ÑÑÐ¾Ð±Ñ Ð´ÑÐ±Ð»Ñ Ð½Ðµ Ð·Ð°Ð²Ð¾Ð´Ð¸Ð»ÑÑ Ð¾Ð´Ð½Ð¸Ð¼ Ð½ÐµÐ¾Ð±Ð´ÑÐ¼Ð°Ð½Ð½ÑÐ¼ ÐºÐ»Ð¸ÐºÐ¾Ð¼
export const defaultAnswer = (group) =>
  group.suggestedId == null ? null : complectationOptions(group).find((o) => o.value === group.suggestedId) || null;

// Ð­ÑÐ¾Ñ ÑÐ°Ð³ ÑÐµÑÐ°ÐµÑ ÑÐ¾Ð»ÑÐºÐ¾ ÐºÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ. ÐÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð½Ðµ ÑÐ»ÑÐ¼ (0): Ð±ÑÐº Ð·Ð°Ð¿Ð¾Ð¼Ð½Ð¸Ñ Ð¾ÑÐ²ÐµÑ Ð¸
// Ð¿ÐµÑÐµÐ²ÐµÐ´ÑÑ ÑÑÑÐ¾ÐºÑ Ð½Ð° Ð²ÐºÐ»Ð°Ð´ÐºÑ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ñ, Ð³Ð´Ðµ Ð¾Ð½Ð¾ Ð·Ð°Ð´Ð°ÑÑÑÑ Ð¸ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÐµÑÑÑ ÑÐ²Ð½Ð¾
export const buildComplectationResolution = (row, answer) => {
  return {
    fileName: row.fileName || null,
    row: row.row,
    markId: row.resolvedMarkId,
    modelId: row.resolvedModelId,
    complectationTitle: row.complectationName || '',
    complectationId: answer.value === NEW_COMPLECTATION ? null : answer.value,
    createComplectation: answer.value === NEW_COMPLECTATION,
    cityId: row.resolvedCityId,
    dcId: row.resolvedDcId,
    vin: row.vin,
    color: row.color || '',
    engineVolume: row.engineVolume || '',
    engineType: row.engineType || null,
    transmission: row.transmission || null,
    priceStr: row.priceStr,
    issueYear: row.yearStr,
    originCarId: 0,
    factoryId: null,
  };
};
